import React, { useEffect } from "react"
import ShareReading from "./share-reading"
import { titleCase } from "../utils/text"
import OutrosJogos from "./outros-jogos"
import { mostrarResultado } from "../utils/scroll"

// GA4: tirada completada (denominador del funnel: cuántos terminan una tirada
// Se dispara al montar el resultado, una vez por tirada.
const trackReadingComplete = (game, pageType) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "reading_complete", {
      game: game || "oraculo",
      page_type: pageType || game || "oraculo",
    })
  }
}

// Panel unificado del RESULTADO de una tirada (máxima intención de compra).
// Reemplaza los viejos bloques .media sueltos ("Nome:", "Título:"...) por una
// "tirada" real: 3 cartas con su posición (Situação · Desafio · Tendência, etc.),
// que sube el valor percibido de la lectura gratis y encadena directo con el
// share (loop viral). Cada juego normaliza sus datos a `cards`.
//
// cards: [{ image, title, subtitle?, badge?, lines: [{ label?, text }] }]
// positions: ["Situação", "Desafio", "Tendência"] (opcional; se emparejan por índice)
const ReadingResult = ({
  cards = [],
  positions = [],
  game,
  pageType,
  onReset,
  resetLabel = "Jogar de novo",
}) => {
  const titleRef = React.useRef(null)
  useEffect(() => {
    trackReadingComplete(game, pageType)
    // En mobile el mazo mide varias pantallas: al completar la tirada, llevar la vista
    // al resultado y anunciarlo (foco en el título) para lectores de pantalla.
    mostrarResultado(titleRef.current)
  }, [game, pageType])

  // El JSON del tarot trae los nombres en MAYÚSCULAS: normalizar para pantalla y share.
  const pretty = title => (game === "jogo-de-tarot" ? titleCase(title) : title)

  return (
  <div className="reading-result">
    <h2 className="reading-result-title" ref={titleRef} tabIndex={-1}>
      <span aria-hidden="true">🌙</span> Sua tirada
    </h2>
    <div className="reading-cards">
      {cards.map((card, i) => (
        <article className="reading-card" key={i}>
          <div className="reading-card-imgwrap">
            <img src={card.image} alt={card.title} loading="lazy" />
            {card.badge && <span className="reading-card-badge">{card.badge}</span>}
          </div>
          <div className="reading-card-body">
            {positions[i] && (
              <span className="reading-card-pos">{positions[i]}</span>
            )}
            <h3 className="reading-card-name">{pretty(card.title)}</h3>
            {card.subtitle && (
              <p className="reading-card-sub">{card.subtitle}</p>
            )}
            <div className="reading-card-lines">
              {card.lines
                .filter(l => l && l.text)
                .map((l, j) => (
                  <p key={j}>
                    {l.label && <strong>{l.label}: </strong>}
                    {l.text}
                  </p>
                ))}
            </div>
          </div>
        </article>
      ))}
    </div>

    <div className="reading-result-actions">
      <ShareReading game={game} cards={cards.map(c => pretty(c.title))} />
      {onReset && (
        <button type="button" className="reading-reset" onClick={onReset}>
          <span aria-hidden="true">↻</span> {resetLabel}
        </button>
      )}
    </div>

    {/* Acá sí lo ve quien terminó la tirada: el bloque del pie queda a dos mil
        píxeles, detrás de todo el texto. */}
    <OutrosJogos atual={`/${pageType === "jogo-de-tarot" ? "" : "oraculo/"}${pageType}/`}
      quantos={3} titulo="Experimente também" />
  </div>
  )
}

export default ReadingResult
